'use strict';
(function () {
	angular.module('onboarding.services')
		.factory('carrierRegistrationService', carrierRegistrationService);

	carrierRegistrationService.$inject = ['$http'];

	function carrierRegistrationService($http) {

		var _carrier = {};

		return {
			validateDotNumber: validateDotNumber,
			validateIntrastateCode: validateIntrastateCode,
			getCarrier: getCarrier,
			setCarrier: setCarrier,
			registerCarrier: registerCarrier,
			lookupCarrierCompanyInfo: lookupCarrierCompanyInfo,
			updateCarrierCompanyInfo: updateCarrierCompanyInfo,
			lookupCarrierFleetServices: lookupCarrierFleetServices,
			updateEquipmentInfo: updateEquipmentInfo,
			lookupPreferredAreasLanes: lookupPreferredAreasLanes,
			updatePreferredLanes: updatePreferredLanes,
			updatePreferredAreas: updatePreferredAreas,
			lookupCarrierDocuments: lookupCarrierDocuments,
			lookupCarrierDocumentFile: lookupCarrierDocumentFile,
			insertCarrierDocument: insertCarrierDocument,
			updateCarrierDocument: updateCarrierDocument,
			lookupContactsReferences: lookupContactsReferences,
			updateCarrierContact: updateCarrierContact,
			updateCarrierReferences: updateCarrierReferences,
			getCarrierTaxInfo: getCarrierTaxInfo,
			updateW8TaxInformation: updateW8TaxInformation,
			updateW9TaxInformation: updateW9TaxInformation,
			lookupInsuranceInformation: lookupInsuranceInformation,
			submitRegistryInsuranceInfo: submitRegistryInsuranceInfo,
			updateDobInsurance: updateDobInsurance,
			lookupCarrierStatus: lookupCarrierStatus,
			visitedSection: visitedSection,
			lookupContractsAndSignatures: lookupContractsAndSignatures,
			signStandardContract: signStandardContract,
			signAssuresignContract: signAssuresignContract,
			sendProfileCompleteNotification: sendProfileCompleteNotification,
			lookupUrlsByCategory: lookupUrlsByCategory,
			lookupBrokers: lookupBrokers,
			lookupSignatures: lookupSignatures,
			updateCarrierPassword: updateCarrierPassword,
			updateCarrierEmail: updateCarrierEmail,
			lookupCarrierProfileModal: lookupCarrierProfileModal,
			shareDocuments: shareDocuments,
			facsimileSignatures: facsimileSignatures
		};
		function lookupCarrierProfileModal(carrierId){
			return $http.get('/api/carriersettings/profile', { params: { carrierId: carrierId } });
		}
		function updateCarrierPassword(password, carrierId){
			var request = {
				newValue : password
			};
			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.post('/api/carriersettings/changepassword', request);
		}

		function updateCarrierEmail(email, carrierId){
			var request = {
				newValue : email
			};
			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.post('/api/carriersettings/changeemail', request);
		}
	
		function validateDotNumber(dotNumber) {
			return $http.get('/api/carrierregistration/validateDotNumber', { params: { dotNumber: dotNumber } });
		}

		function validateIntrastateCode(intrastateState, intrastateCode) {
			return $http.get('/api/carrierregistration/validateIntrastateCode',
				{ params: { intrastateState: intrastateState, intrastateCode: intrastateCode } });
		}

		function getCarrier() {
			return _carrier;
		}

		function setCarrier(carrier) {
			_carrier = carrier;
		}

		function registerCarrier(tcoreId, firstName, lastName, title, phoneNumber, phoneExt, email, password) {
			var request = {
				tcoreId: tcoreId,
				firstName: firstName,
				lastName: lastName,
				title: title,
				phoneNumber: phoneNumber,
				phoneExt: phoneExt,
				email: email,
				password: password
			};

			return $http.post('/api/carrierregistration/registerCarrier', request);
		}

		function lookupCarrierCompanyInfo(carrierId) {
			if (carrierId) {
				return $http.get('/api/carrierregistration/lookupCarrierCompanyInfo',
					{ params: { carrierId: carrierId } });
			} else {
				return $http.get('/api/carrierregistration/lookupCarrierCompanyInfo');
			}
		}

		function lookupCarrierFleetServices(carrierId) {
			if (carrierId > -1) {
				return $http.get('/api/carrierregistration/lookupCarrierEquipment',
					{ params: { carrierId: carrierId } });
			} else {
				return $http.get('/api/carrierregistration/lookupCarrierEquipment');
			}
		}

		function updateCarrierCompanyInfo(carrierId,
			companyType,
			yearFounded,
			SCAC,
			isWomanOwned,
			isVeteranOwned,
			isDisabledVeteranOwned,
			isMinorityOwned,
			minorityType,
			isNmsdcCertified,
			regionalCouncil,
			certificationNumber,
			physicalAddress,
			mailingAddressSameAsPhysicalAddress,
			mailingAddress,
			remitToAddressSameAsPhysicalAddress,
			remitToAddressSameAsMailingAddress,
			remitToName,
			remitToAddress,
			interestInQuickPay,
			isFactoring) {


			if (typeof SCAC === 'string') {
				SCAC = SCAC.split(/, ?/);
			}

			var requestPhysicalAddress =
			{
				street: physicalAddress.street,
				city: physicalAddress.city,
				stateProvince: physicalAddress.stateProvince,
				postalCode: physicalAddress.postalCode,
				phoneNumber: physicalAddress.phoneNumber,
				phoneExtension: physicalAddress.phoneExt,
				countryCode: physicalAddress.countryCode
			};
			if (typeof requestPhysicalAddress.postalCode === 'string')
				var requestMailingAddress =
				{
					street: mailingAddress.street,
					city: mailingAddress.city,
					stateProvince: mailingAddress.stateProvince,
					postalCode: mailingAddress.postalCode,
					phoneNumber: mailingAddress.phoneNumber,
					phoneExtension: mailingAddress.phoneExt,
					countryCode: mailingAddress.countryCode
				};
			if (typeof requestMailingAddress.postalCode === 'string') {
				//requestMailingAddress.postalCode = requestMailingAddress.postalCode = requestMailingAddress.postalCode.replace(/-/g, '');
			} else requestMailingAddress = null;

			var requesRemitToAddress =
			{
				street: remitToAddress.street,
				city: remitToAddress.city,
				stateProvince: remitToAddress.stateProvince,
				postalCode: remitToAddress.postalCode,
				phoneNumber: remitToAddress.phoneNumber,
				phoneExtension: remitToAddress.phoneExt,
				countryCode: remitToAddress.countryCode
			};
			if (typeof requesRemitToAddress.postalCode === 'string') {
				//requesRemitToAddress.postalCode = requesRemitToAddress.postalCode.replace(/-/g, '');
			} else
				requesRemitToAddress = null;

			var request = {
				companyType: companyType,
				yearFounded: yearFounded,
				SCAC: SCAC,
				isWomanOwned: isWomanOwned,
				isVeteranOwned: isVeteranOwned,
				isDisabledVeteranOwned: isDisabledVeteranOwned,
				isMinorityOwned: isMinorityOwned,
				minorityType: minorityType,
				isNmsdcCertified: isNmsdcCertified,
				regionalCouncil: regionalCouncil,
				certificationNumber: certificationNumber,
				physicalAddress: requestPhysicalAddress,
				mailingAddressSameAsPhysicalAddress: mailingAddressSameAsPhysicalAddress,
				mailingAddress: requestMailingAddress,
				remitToAddressSameAsPhysicalAddress: remitToAddressSameAsPhysicalAddress,
				remitToAddressSameAsMailingAddress: remitToAddressSameAsMailingAddress,
				remitToName: remitToName,
				remitToAddress: requesRemitToAddress,

				interestInQuickPay: interestInQuickPay,
				isFactoring: isFactoring
			};

			if (carrierId > -1)
				request.carrierId = carrierId;

			return $http.post('/api/carrierregistration/carrierCompanyInfo', request);
		}

		function updateEquipmentInfo(carrierId,
			hasNoTrailers,
			isInternational,
			hasDangerousGoods,
			hasSecurityCerts,
			hasEnvironmentalCerts,
			hasLtlCapabilities,
			numberOfPowerUnits,
			numberOfTeams,
			numberOfOwnerOperators,
			numberOfCompanyDrivers,
			communicationType,
			trailers,
			hasAirRide,
			hasVented,
			hasHotshot,
			hasCurtains,
			hasInsulated,
			hasConestoga,
			hasCoilRacks,
			hasContainerLocks,
			hasTarps,
			hasEtrac,
			hasGarmentRacks,
			hasPadWrap,
			hasStraps,
			hasChains,
			isHazmatCertified,
			isRadioactiveCertified,
			isResponsibileCare,
			isAceCertified,
			isCtpatMember,
			isTwicCardholder,
			isTsaRegistered,
			isSmartwayCarrier,
			hasCarbCompliantTrucks,
			isCarbCompliantTru,
			doesParcels,
			isUpsCarrier,
			hasLtlCapabilties,
			hasExpeditedGround,
			doesMultipleStops,
			handlesRailDryage,
			handlesPortDryage,
			handlesAirFreightCartage,
			handlesEdi,
			hasSpottedTrailers,
			handlesOversizeLoads,
			doesTrailerInterchange,
			doesPalletExchange,
			doesBrokerage,
			otherServices,
			airports,
			ports,
			hasDropOffPort) {


			var request = {
				carrierId: carrierId,
				hasNoTrailers: hasNoTrailers,
				isInternational: isInternational,
				hasDangerousGoods: hasDangerousGoods,
				hasSecurityCerts: hasSecurityCerts,
				hasEnvironmentalCerts: hasEnvironmentalCerts,
				hasLtlCapabilities: hasLtlCapabilities,
				hasDropOffPort: hasDropOffPort,
				equipment: {
					numberOfPowerUnits: numberOfPowerUnits,
					numberOfTeams: numberOfTeams,
					numberOfOwnerOperators: numberOfOwnerOperators,
					numberOfCompanyDrivers: numberOfCompanyDrivers,
					communicationType: communicationType,
					trailers: trailers,
					hasAirRide: hasAirRide,
					hasVented: hasVented,
					hasHotshot: hasHotshot,
					hasCurtains: hasCurtains,
					hasInsulated: hasInsulated,
					hasConestoga: hasConestoga,
					hasCoilRacks: hasCoilRacks,
					hasContainerLocks: hasContainerLocks,
					hasTarps: hasTarps,
					hasEtrac: hasEtrac,
					hasGarmentRacks: hasGarmentRacks,
					hasPadWrap: hasPadWrap,
					hasStraps: hasStraps,
					hasChains: hasChains
				},
				services: {
					isHazmatCertified: isHazmatCertified,
					isRadioactiveCertified: isRadioactiveCertified,
					isResponsibileCare: isResponsibileCare,
					isAceCertified: isAceCertified,
					isCtpatMember: isCtpatMember,
					isTwicCardholder: isTwicCardholder,
					isTsaRegistered: isTsaRegistered,
					isSmartwayCarrier: isSmartwayCarrier,
					hasCarbCompliantTrucks: hasCarbCompliantTrucks,
					isCarbCompliantTru: isCarbCompliantTru,
					doesParcels: doesParcels,
					isUpsCarrier: isUpsCarrier,
					hasLtlCapabilties: hasLtlCapabilties,
					hasExpeditedGround: hasExpeditedGround,
					doesMultipleStops: doesMultipleStops,
					handlesRailDryage: handlesRailDryage,
					handlesPortDryage: handlesPortDryage,
					handlesAirFreightCartage: handlesAirFreightCartage,
					handlesEdi: handlesEdi,
					hasSpottedTrailers: hasSpottedTrailers,
					handlesOversizeLoads: handlesOversizeLoads,
					doesTrailerInterchange: doesTrailerInterchange,
					doesPalletExchange: doesPalletExchange,
					doesBrokerage: doesBrokerage,
					otherServices: otherServices,
					airports: airports,
					ports: ports
				}
			};

			return $http.post('/api/carrierregistration/updateCarrierEquipment', request);
		}

		function lookupPreferredAreasLanes(carrierId) {
			return $http.get('/api/carrierregistration/preferredAreasLanes', { params: { carrierId: carrierId } });
		}

		function updatePreferredLanes(originState,
			originMetroCode,
			originMetroName,
			destinationState,
			destinationMetroCode,
			destinationMetroName,
			isRemove,
			carrierId) {
			var request = {
				originState: originState,
				originMetroCode: originMetroCode,
				originMetroName: originMetroName,
				destinationState: destinationState,
				destinationMetroCode: destinationMetroCode,
				destinationMetroName: destinationMetroName,
				isRemove: isRemove
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/preferredLanes', request);
		}

		function updatePreferredAreas(states, hasMexicoService, carrierId) {
			var request = {
				states: states,
				hasMexicoService: hasMexicoService
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/preferredAreas', request);
		}

		function lookupCarrierDocuments(carrierId) {
			return $http.get('/api/carrierregistration/carrierDocuments', { params: { carrierId: carrierId } });
		}

		function lookupCarrierDocumentFile(documentId) {
			return $http.get('/api/carrierregistration/carrierDocument', { params: { documentId: documentId } });
		}

		function insertCarrierDocument(fileName,
			fileExtension,
			mimeType,
			fileContent,
			description,
			documentType,
			documentName,
			carrierId) {
			var request = {
				fileName: fileName,
				fileExtension: fileExtension,
				mimeType: mimeType,
				fileContent: fileContent,
				description: description,
				documentType: documentType,
				documentName: documentName
			};

			if (carrierId) {
				request.carrierId = carrierId;
			}

			return $http.post('/api/carrierregistration/carrierDocument', request);
		}

		function updateCarrierDocument(documentId, description, documentType, documentName, documentStatus, carrierId) {

			var request = {
				documentId: documentId,
				description: description,
				documentType: documentType,
				documentName: documentName,
				documentStatus: documentStatus
			};

			if (carrierId) {
				request.carrierId = carrierId;
			}

			return $http.put('/api/carrierregistration/carrierDocument', request);
		}

		function lookupContactsReferences(carrierId) {
			return $http.get('/api/carrierregistration/contactsReferences', { params: { carrierId: carrierId } });
		}

		function updateCarrierReferences(referenceIndex,
			action,
			companyName,
			name,
			phoneNumber,
			phoneExtension,
			carrierId) {

			var request = {
				referenceIndex: referenceIndex,
				action: action,
				companyName: companyName,
				contactName: name,
				phone: phoneNumber,
				phoneExtension: phoneExtension
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/references', request);
		}

		function updateCarrierContact(action,
			name,
			role,
			title,
			phone,
			phoneExtension,
			fax,
			email,
			isPrimary,
			carrierId) {

			var request = {
				action: action,
				name: name,
				role: role,
				title: title,
				phone: phone,
				phoneExtension: phoneExtension,
				fax: fax,
				email: email,
				isPrimary: isPrimary
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/contacts', request);
		}

		function getCarrierTaxInfo(carrierId) {
			if (!carrierId) {
				carrierId = -1;
			}

			return $http.get('/api/carrierregistration/taxInformation',{ params: { carrierId: carrierId } });
		}

		function updateW8TaxInformation(name,
			typeOfBeneficialOwner,
			address,
			city,
			state,
			postalCode,
			country,
			mailingAddress,
			mailingCity,
			mailingState,
			mailingPostalCode,
			mailingCountry,
			tin,
			federalTaxType,
			foreignTaxId,
			foreignTaxIdType,
			carrierId) {
			var request = {
				name: name,
				typeOfBeneficialOwner: typeOfBeneficialOwner,

				address: address,
				city: city,
				state: state,
				country: country,
				postalCode: postalCode,

				mailingAddress: mailingAddress,
				mailingCity: mailingCity,
				mailingState: mailingState,
				mailingCountry: mailingCountry,
				mailingPostalCode: mailingPostalCode,

				tin: tin,
				federalTaxIdType: federalTaxType,

				foreignTaxId: foreignTaxId,
				foreignTaxIdType: foreignTaxIdType
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/w8TaxInformation', request);
		}

		function updateW9TaxInformation(name,
			businessName,
			federalTaxClassification,
			otherText,
			exemptPayeeCode,
			factaReportingCode,
			address,
			city,
			state,
			postalCode,
			tin,
			federalTaxType,
			carrierId) {
			var request = {
				name: name,
				businessName: businessName,
				federalTaxClassification: federalTaxClassification,
				otherText: otherText,
				exemptPayeeCode: exemptPayeeCode,
				factaReportingCode: factaReportingCode,
				address: address,
				city: city,
				state: state,
				postalCode: postalCode,
				tin: tin,
				federalTaxType: federalTaxType
			};
			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.put('/api/carrierregistration/w9TaxInformation', request);
		}

		function lookupInsuranceInformation(carrierId) {
			if (!carrierId) {
				carrierId = -1;
			}

			return $http.get('/api/carrierregistration/insuranceInformation', { params: { carrierId: carrierId } });
		}

		function submitRegistryInsuranceInfo(carrierId, agents, otherFeedback) {
			var request = {
				carrierId: carrierId,
				agents: agents,
				otherFeedback: otherFeedback
			};

			return $http.post('/api/carrierregistration/agentFeedback', request);
		}

		function updateDobInsurance(carrierId,
			agentId,
			agentName,
			phone,
			extension,
			fax,
			hasAuto,
			hasCargo,
			hasGeneral,
			hasWorkersComp,
			email,
			fileName,
			fileExtension,
			fileContent,
			mimeType,
			hadCert) {

			var request = {
				agentName: agentName,
				phone: phone,
				extension: extension,
				fax: fax,
				hasAuto: hasAuto,
				hasCargo: hasCargo,
				hasGeneral: hasGeneral,
				hasWorkersComp: hasWorkersComp,
				email: email,
				fileName: null,
				fileExtension: null,
				fileContent: null,
				mimeType: null
			};
			if (fileContent) {
				request.fileName = fileName;
				request.fileExtension = fileExtension,
				request.fileContent = fileContent;
				request.mimeType = mimeType;
			} else if (hadCert && !fileName) {
				request.deleteCertificate = true;
			}

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			if (agentId) {
				request.agentId = agentId;
			} else {
				request.agentId = -1;
			}

			return $http.put('/api/carrierregistration/insuranceInformation', request);
		}

		function lookupCarrierStatus(carrierId) {
			return $http.get('/api/carrierregistration/lookupCarrierStatus', { params: { carrierId: carrierId } });
		}

		function visitedSection(section, carrierId, brokerId) {
			var request = {
				section: section,
				carrierId: carrierId,
				brokerId: brokerId
			};

			if (!carrierId) {
				request.carrierId = -1;
			}

			if (!brokerId) {
				request.brokerId = -1;
			}

			return $http.put('/api/carrierregistration/visitedSection', request);
		}

		function lookupContractsAndSignatures(carrierId, brokerId) {
			if (!carrierId) {
				carrierId = -1;
			}

			if (!brokerId) {
				brokerId = -1;
			}

			return $http.get('/api/carrierregistration/lookupContractsAndSignatures',
				{ params: { carrierId: carrierId, brokerId: brokerId } });
		}

		function signStandardContract(signee, signeeTitle, contractId) {
			var request = {
				signee: signee,
				signeeTitle: signeeTitle,
				contractId: contractId
			};

			return $http.put('/api/carrierregistration/signStandardContract', request);
		}

		function signAssuresignContract(signee, signeeTitle, brokerId, callbackUrl) {
			var request = {
				signee: signee,
				signeeTitle: signeeTitle,
				brokerId: brokerId,
				callbackUrl: callbackUrl
			};

			return $http.put('/api/carrierregistration/signAssuresignContract', request);
		}

		function sendProfileCompleteNotification(carrierId) {
			return $http.get('/api/carrierregistration/SendProfileCompletedNotice', { params: { carrierId: carrierId } });
		}

		function lookupUrlsByCategory(businessUnitId) {
			return $http.get('/api/carrierregistration/lookupUrlsByCategory', { params: { businessUnitId: businessUnitId } });
		}

		function lookupBrokers(carrierId) {
			return $http.get('/api/carrierregistration/lookupBrokers', { params: { carrierId: carrierId } });
		}

		function lookupSignatures(carrierId, brokerId) {
			return $http.get('/api/carrierregistration/lookupSignatures', { params: { carrierId: carrierId, brokerId: brokerId } });
		}

		function shareDocuments(documents, carrierId) {
			var request = {
				documentGuids: documents
			};

			if (carrierId) {
				request.carrierId = carrierId;
			} else {
				request.carrierId = -1;
			}

			return $http.post('/api/carrierregistration/shareDocuments', request);
		}
	
		function facsimileSignatures(documentId) {
			return $http.get('/api/carrierregistration/facsimileSignatures', { params: { documentId: documentId } });
		}
	}
})();
